import { mutationTypes, actionTypes } from '../../../types';
import { logger } from '../../../tools';

/** Function to send Head request to Server used vor Offline Apps to prevent iOS Webserver from sleeping
 *
 * @param callback
 */
// function sendKeepAlivePacket(callback) {
// 	// console.log('interface Native keep alive Request!');
// 	$.ajax({
// 		type: 'HEAD',
// 		async: true,
// 		cache: false,
// 		url: window.parent.location.href,
// 		success: () => {
// 			callback(true);
// 		},
// 		error: message => {
// 			callback(message);
// 		},
// 	});
// }

export default store => {
	/** offline Content **/
	window.nativeOnAppOfflineAppCheckResult = function(result) {
		console.log('nativeOnAppOfflineAppCheckResult: result ' + result);
		try {
			// offlineAppCheckInterface.notify(result); // TODO: implement
		} catch (e) {
			console.log(
				nativeCallBacksModuleName,
				'nativeOnAppOfflineAppCheckResult:' + e + 'during result ' + result
			);
		}
	};

	/*
 Inform webview about sync progress
 */
	window.nativeOnAppOfflineAppSyncProgress = (appsProcessed, appsTotal, error) => {
		logger.log('nativeOnAppOfflineAppSyncProgress', { appsProcessed, appsTotal, error });
		store.commit(mutationTypes.packageSyncerSetProgress, { appsProcessed, appsTotal, error });
		if (error !== null && (typeof error === 'string' && error !== 'null')) {
			store.commit(mutationTypes.packageSyncerErrorOccured, {
				message: error,
				action: store.state.packageSyncer.currentAction,
			});
			// store.dispatch(actionTypes.packageSyncerCancelSyncronisation);
		}
		if (appsProcessed === appsTotal) {
			store.dispatch(actionTypes.packageSyncerStoppedSyncronisation);
		}
	};
};
